import React from 'react';

type PreferredPlanItemProps = {
  label: string;
  value: string;
}

const baseString = 'fields-list__detail';

export const PreferredPlanItem = ({ label, value }: PreferredPlanItemProps) => {
  return (
    <div className={`${baseString}-item`}>
      <span className={`${baseString}-label`}>
        {label}
      </span>
      <span className={`${baseString}-value`}>
        {value}
      </span>
    </div>
  );
};
